import React from 'react'

const EmptyPage = () => {
  return (
    <div>
      EMPTY HERE...!
    </div>
  )
}

export default EmptyPage
